<template>
  <div>
    <v-list-item to="/home">
          <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Home</v-list-item-title></v-list-item-content>
      </v-list-item>
    <v-subheader>Navigate</v-subheader>
     <!-- <v-list-item link :to="'/directions'">
        <v-list-item-icon>
          <v-icon>mdi-navigation-variant-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Directions</v-list-item-title>
      </v-list-item> -->
      <v-list-item to="/directions?b=32">
        <v-list-item-icon><v-icon>mdi-directions</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title>Directions</v-list-item-title></v-list-item-content>
    </v-list-item>
    <v-subheader>Maps</v-subheader>
    <div v-for="(building, i) in buildings" :key="i">
        <v-list-item link :to="'/maps/'+building">
          <v-list-item-icon>
            <v-icon>mdi-map-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Building {{building}}</v-list-item-title>
        </v-list-item>
    </div>
  </div>
</template>

<script>
import MitSpacesService from '../../services/MitSpacesService.js';

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
      buildings:[],
    }
  },
  created() {
      //get current settings
      MitSpacesService.getBuildingsMitIdUniqueList()
      .then((buildings) => {
          this.loadingBuildings = false;
          this.buildings = buildings;
          //select the first one by default
          if(this.buildings.length > 0){
              this.selectedBuilding = 0;
              this.selectBuilding();
          }
      })
      .catch((error)=>{
          this.loadingBuildings = false;
      });
  }

}
</script>

<style lang="scss" scoped>
</style>
